

/**
 * CategMiniFactory.js
 */

class CategMiniFactory extends CategFactorable {

	constructor(resultData, or34) {
		super(resultData, or34);

		this._nbMini = this.makeNbMini();
		//
		this._miniRankArray = [ "all", "ten", "one" ];

		this._makeBooArrayProcessMap = {
			all: this.makeBooArrayAll,
			ten: this.makeBooArrayTen,
			one: this.makeBooArrayOne
		};
		
		this._makePercentProcessMap = {  all: this.makePerAll, ten: this.makePer, one: this.makePer  };
		//
		this._defNbArray = this.makeDefNbArray();

	};


	get or34() {   return this._or34;   };

	get nb() {   return this._nb;   };

	get nb3() { return this._nb3; };

	get resultMap() { return this._resultMap; };
	//

	get nbMini() { return this._nbMini; }

	get miniRankArray() {   return this._miniRankArray;   }

	//


	makeNbMini() {
		let nb = this._nb;
		let mini = [];
		for(let i=0, n=nb.length; i<n; i++) {
			let arr = [ nb[i][1], nb[i][2] ];
			mini[i] = arr;
		};
		return mini;
	};

	makeDefNbArray() {
		let arr = [];
		for(let i=0; i<10; i++) {
			for(let j=0; j<10; j++) {
				arr[i*10+j] = [ i,j ];
			};
		};
		return arr;
	};


	getBooArray(rank, bit0_9, is) {

		let booArray = [];
		for(let i=0, n=this._miniRankArray.length; i<n; i++) {
			if(rank===this._miniRankArray[i]) {
				booArray = this._makeBooArrayProcessMap[rank](this._nbMini, bit0_9, is);
			};
		};
		return booArray;
	};
	makeBooArrayAll(nbMini, bit0_9, is) {
		let array = [];
		let bitBoo = CategMiniFactory.changeBit0_9_toBooArray(bit0_9);
		for(let i=0, n=nbMini.length; i<n; i++) {
			if(bit0_9===0) {
				array.push(true);
			}else {
				let arr = nbMini[i];
				let boo = !is;
				for(let j=0, m=bitBoo.length; j<m; j++) {
					if(is) {
						if(bitBoo[j]) {
							if(arr[0]==j || arr[1]==j){  boo = true;  break; };
						};
					}else {
						if(bitBoo[j]) {
							if(arr[0]==j || arr[1]==j){  boo = false;  break;  };
						};
					};
				};
				array.push(boo);
			};
		};
		return array;
	};
	makeBooArrayTen(nbMini, bit0_9, is) {

		let array = [];
		let bitBoo = CategMiniFactory.changeBit0_9_toBooArray(bit0_9);
		for(let i=0, n=nbMini.length; i<n; i++) {
			if(bit0_9===0) {
				array.push(true);
			}else {
				let arr = nbMini[i];
				let boo = !is;
				for(let j=0, m=bitBoo.length; j<m; j++) {
					if(is) {
						if(bitBoo[j]) {
							if(arr[0]==j){  boo = true;  break; };
						};
					}else {
						if(bitBoo[j]) {
							if(arr[0]==j){  boo = false;  break;  };
						};
					};
				};
				array.push(boo);
			};
		};
		return array;
	};
	makeBooArrayOne(nbMini, bit0_9, is) {
		let array = [];
		let bitBoo = CategMiniFactory.changeBit0_9_toBooArray(bit0_9);
		for(let i=0, n=nbMini.length; i<n; i++) {
			if(bit0_9===0) {
				array.push(true);
			}else {
				let arr = nbMini[i];
				let boo = !is;
				for(let j=0, m=bitBoo.length; j<m; j++) {
					if(is) {
						if(bitBoo[j]) {
							if(arr[1]==j){  boo = true;  break; };
						};
					}else {
						if(bitBoo[j]) {
							if(arr[1]==j){  boo = false;  break;  };
						};
					};
				};
				array.push(boo);
			};
		};
		return array;
	};


	static changeBit0_9_toBooArray(bit) {
		let booArray = new Array(10);
		for(let i=0; i<10; i++) {
			booArray[i] = (Math.pow(2,i) & bit)>0 ? true : false ;
		};
		return booArray;
	};

	static bit0_9Count(bit) {
		let count = 0;
		for(let i=0; i<10; i++) {
			count += (Math.pow(2,i) & bit)>0 ? 1 : 0 ;
		};
		return count;
	};


	//
	getDefBooArray(rank, bit0_9, is, targetList=this._defNbArray) {
		let booArray = [];
		for(let i=0, n=this._miniRankArray.length; i<n; i++) {
			if(rank===this._miniRankArray[i]) {
				booArray = this._makeBooArrayProcessMap[rank](targetList, bit0_9, is);
			};
		};
		return booArray;
	};



	//  get percent
	getPercent(rank, bit0_9, is) {

		let percent = 100.0;
		for(let i=0, n=this._miniRankArray.length; i<n; i++) {
			if(rank===this._miniRankArray[i]) {
				percent = this._makePercentProcessMap[rank](bit0_9, is);
			};
		};
		return percent;
	};
	makePer(bit, is) {
		let count = CategMiniFactory.bit0_9Count(bit);
		return is ? count*10 : (10-count)*10;
	};
	makePerAll(bit, is) {
		let count = CategMiniFactory.bit0_9Count(bit);
		let aa = Math.pow(10-count, 2);
		return is ? 100-aa : aa;
	};




	getResultNbListForList(objList, isText=true) {

		let resultList = this._defNbArray;
		for(let i=0, n=objList.length; i<n; i++) {
			resultList = this.getResultNbList(objList[i].rank, objList[i].bit, objList[i].is, false, resultList);
		};
		if(isText) {
			return resultList.map((val)=>CategMiniFactory.arrayToNumb(val));
		}else {
			return resultList;
		};
	};


	getResultNbList(rank, bit0_9, is, isText=true, targetList=this._defNbArray) {

		let resultList = [];
		let booArray = [];
		for(let i=0, n=this._miniRankArray.length; i<n; i++) {
			if(rank===this._miniRankArray[i]) {
				booArray = this._makeBooArrayProcessMap[rank](targetList, bit0_9, is);
			};
		};
		for(let i=0, n=booArray.length; i<n; i++) {
			if(booArray[i]) {   resultList.push(targetList[i]);   };
		};
		if(isText) {
			return resultList.map((val)=>CategMiniFactory.arrayToNumb(val));
		}else {
			return resultList;
		};
	};
	static arrayToNumb(array) {
		let result = '';
		for(let i=0, n=array.length; i<n; i++) {
			result += array[i];
		};
		return result;
	};


	//
	_booArrayCount(booArray) {
		let count = 0;
		for(let i=0, n=booArray.length; i<n; i++) {
			if(booArray[i]) {   count++;   };
		};
		return count;
	}



};
